/* eslint-disable max-len */
import React, { useState } from 'react';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

export default function MultiSelect(props) {
  const {
    id,
    options,
    currentlySelected,
    disabled = false,
  } = props;

  const shallowComparison = (a, b) => {
    if (typeof a !== 'object' || typeof b !== 'object') return (a === b);

    const keysA = Object.keys(a);
    const keysB = Object.keys(b);

    if (keysA.length !== keysB.length) {
      return false;
    }

    return keysA.every((key) => a[key] === b[key]);
  };

  let initialValue;
  const multipleSelected = [];
  const idName = `${id}_control`;

  currentlySelected?.forEach((selectedVal) => {
    options.forEach((rowToCompare) => {
      if (shallowComparison(rowToCompare.id, selectedVal)) {
        multipleSelected.push(rowToCompare);
        initialValue = multipleSelected;
      }
    });
  });

  const [selectedValue, setSelectedValue] = useState(initialValue);

  return (
    <>
      <Autocomplete
        disablePortal
        multiple
        id={idName}
        options={options}
        value={selectedValue}
        disabled={disabled}
        getOptionLabel={(option) => option.label}
        filterSelectedOptions
        onChange={(_event, value) => {
          setSelectedValue(value);
        }}
        renderTags={(tagValue, getTagProps) => tagValue.map((option, index) => {
          const { key, ...tagProps } = getTagProps({ index });
          return (
            <Chip
              id={`weekDay_${option.label}`}
              key={key}
              label={option.label}
              {...tagProps}
            />
          );
        })}
        renderInput={(params) => (
          <TextField
            {...params}
          />
        )}
      />
    </>
  );
}
